import React from 'react';
import moment from 'moment';
import InboxEmpty from '../InboxEmpty/InboxEmpty';
import './inbox-announcements-list.scss';

const InboxAnnouncementsList = ({
  announcementsList,
  onSelectItem,
  selectedId,
  loader,
}) => {
  return announcementsList && announcementsList.length > 0
    ? announcementsList.map((item, i) => {
        return (
          <div
            className={
              item.id === selectedId
                ? 'inbox-announcement-row selected'
                : 'inbox-announcement-row'
            }
            key={i}
            onClick={() => onSelectItem(item)}
          >
            <div className="thread-icon">
              {' '}
              <img src="/assets/Announcement.png" alt="" />{' '}
            </div>
            <div className="thread-info">
              <div className="timestamp">
                {moment(item.announcementDate).format('MM/DD/YYYY')}
              </div>
              <div className="property-name">{item.propertyName}</div>
              <div className="description">{item.title} </div>
            </div>
          </div>
        );
      })
    : !loader && <InboxEmpty message={'No announcements found.'} />;
};

export default InboxAnnouncementsList;